<template lang="pug">
v-card
  .d-flex.pt-2.px-4.jc-center.ai-center
    .flex-1.d-flex.fd-column
      span.pa-0.font-size-20.font-weight-700(:class="{'font-size-17' : isMovil}") Configuración de exportación
      span.font-size-12.text-muted.pl-0 Selecciona el formato y las columnas a exportar
    .d-flex
      .mx-1.flex-1(v-if="descripcionPredefinido")
        v-select(
          v-if="descripcionPredefinido"
          hide-details
          :items='reportesPredefinidos'
          v-model="descripcionPredefinido"
          label='Seleccionar tipo de listado'
          dense=''
          solo=''
          item-text="titulo"
          item-value="descripcion"
        )
      //- .mx-1.flex-1(:class="{'mb-2' : isMovil}")
      //-   v-select(
      //-     hide-details
      //-     :items='formatosExportar'
      //-     v-model="formatoAExportar"
      //-     return-object
      //-     label='Seleccionar formato exportar'
      //-     dense=''
      //-     solo=''
      //-   )

  .d-flex.fd-column
    v-tabs.d-flex.mt-1(v-model='tab'  dense color='primary' grow='')
      v-tab(key='lista')
        v-badge(v-if="countLengthColumns('ticket')" color='primary' dot)
          span Ticket
        span(v-else)
          span Ticket
      v-tab(key='estados')
        v-badge(v-if="countLengthColumns('estado')" color='primary' dot)
          span Estados
        span(v-else) Estados
      v-tab(key='etapas')
        v-badge(v-if="countLengthColumns('etapa')" color='primary' dot)
          span Etapas
        span(v-else) Etapas
      v-tab(key='tiempos')
        v-badge(v-if="countLengthColumns('tiempo')" color='primary' dot)
          span Tiempos
        span(v-else) Tiempos
      v-tab(key='orden')
        v-badge(v-if="columnasAExportar.length" color='primary' :content="columnasAExportar.length")
          span Listo para exportar
        span(v-else) Listo para exportar
    v-card.overflow-y-auto.elevation-0(:height="isMovil ? 'calc(100vh - 228px)'  : 'calc(100vh - 180px)'")
      v-tabs-items(v-model='tab')
        v-tab-item(key='lista')
          v-card.elevation-0
            .d-flex.fd-column.jc-center.ai-center.pa-6.mt-12(v-if="!columnasTicket.length")
              v-icon(color="background", size="100") clear_all
              span.font-weight-700.primary--text
                | No habilitaste ninguna opcion
              span.text-muted.font-size-12 Para visualizar columnas habilita alguna opcion en la parte superior
            .d-flex
              v-switch.mx-4.my-2(v-if="columnasTicket.length" dense hide-details v-model="isColumnasAllSeleccionadasTicket" color="primary" :label="isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas del ticket'" @change="seleccionarTodasLasColumnasTicket")
            v-list.py-0(dense)
              v-list-item-group(v-model='columnasAExportar' multiple='')
                template(v-for='(item, i) in columnasTicket')
                  v-list-item(:key='`item-${i}`' :value='item' active-class='secondary primary--text')
                    template(v-slot:default='{ active }')
                      v-list-item-action
                        v-checkbox(:input-value='active' dense color='primary'  hide-details)
                      v-list-item-content
                        v-list-item-title
                          strong.font-size-12 {{item.nombre}}
                        v-list-item-subtitle
                          span.font-size-11.text-muted columna de {{item.table}}
                      v-list-item-action
                        v-icon(:color="item.color" size="12") circle
                  v-divider
        v-tab-item(key='estados')
          v-card.elevation-0
            .d-flex.fd-column.jc-center.ai-center.pa-6.mt-12(v-if="!columnasEstados.length")
              v-icon(color="background", size="100") clear_all
              span.font-weight-700.primary--text
                | No habilitaste ninguna opcion
              span.text-muted.font-size-12 Para visualizar columnas habilita alguna opcion en la parte superior
            .d-flex
              v-switch.mx-4.my-2(v-if="columnasEstados.length" dense hide-details v-model="isColumnasAllSeleccionadasEstados" color="primary" :label="isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas de los estados'" @change="seleccionarTodasLasColumnasEstados")
            v-list.py-0(dense)
              v-list-item-group(v-model='columnasAExportar' multiple='')
                template(v-for='(item, i) in columnasEstados')
                  v-list-item(:key='`item-${i}`' :value='item' active-class='secondary primary--text')
                    template(v-slot:default='{ active }')
                      v-list-item-action
                        v-checkbox(:input-value='active' dense color='primary'  hide-details)
                      v-list-item-content
                        v-list-item-title
                          strong.font-size-12 {{item.nombre}}
                        v-list-item-subtitle
                          span.font-size-11.text-muted columna de {{item.table}}
                      v-list-item-action
                        v-icon(:color="item.color" size="12") circle
                  v-divider
        v-tab-item(key='etapas')
          v-card.elevation-0
            .d-flex.fd-column.jc-center.ai-center.pa-6.mt-12(v-if="!columnasEtapas.length")
              v-icon(color="background", size="100") clear_all
              span.font-weight-700.primary--text
                | No habilitaste ninguna opcion
              span.text-muted.font-size-12 Para visualizar columnas habilita alguna opcion en la parte superior
            .d-flex
              v-switch.mx-4.my-2( dense v-if="columnasEtapas.length"  hide-details v-model="isColumnasAllSeleccionadasEtapas" color="primary" :label="isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas de las etapas'" @change="seleccionarTodasLasColumnasEtapas")
            v-list.py-0(dense)
              v-list-item-group(v-model='columnasAExportar' multiple='')
                template(v-for='(item, i) in columnasEtapas')
                  v-list-item(:key='`item-${i}`' :value='item' active-class='secondary primary--text')
                    template(v-slot:default='{ active }')
                      v-list-item-action
                        v-checkbox(:input-value='active' dense color='primary'  hide-details)
                      v-list-item-content
                        v-list-item-title
                          strong.font-size-12 {{item.nombre}}
                        v-list-item-subtitle
                          span.font-size-11.text-muted columna de {{item.table}}
                      v-list-item-action
                        v-icon(:color="item.color" size="12") circle
                  v-divider
        v-tab-item(key='tiempos')
          v-card.elevation-0
            .d-flex.fd-column.jc-center.ai-center.pa-6.mt-12(v-if="!columnasTiempos.length")
              v-icon(color="background", size="100") clear_all
              span.font-weight-700.primary--text
                | No habilitaste ninguna opcion
              span.text-muted.font-size-12 Para visualizar columnas habilita alguna opcion en la parte superior
            .d-flex
              v-switch.mx-4.my-2( dense hide-details v-if="columnasTiempos.length"  v-model="isColumnasAllSeleccionadasTiempos" color="primary" :label="isColumnasAllSeleccionadasTicket ? 'Quitar seleccionados' : 'Todas las columnas de los tiempos'" @change="seleccionarTodasLasColumnasTiempos")
            v-list.py-0(dense)
              v-list-item-group(v-model='columnasAExportar' multiple='')
                template(v-for='(item, i) in columnasTiempos')
                  v-list-item(:key='`item-${i}`' :value='item' active-class='secondary primary--text')
                    template(v-slot:default='{ active }')
                      v-list-item-action
                        v-checkbox(:input-value='active' dense color='primary'  hide-details)
                      v-list-item-content
                        v-list-item-title
                          strong.font-size-12 {{item.nombre}}
                        v-list-item-subtitle
                          span.font-size-11.text-muted columna de {{item.table}}
                      v-list-item-action
                        v-icon(:color="item.color" size="12") circle
                  v-divider
        v-tab-item(key='orden')
          v-card.elevation-0
            .d-flex.fd-column.jc-center.ai-center.pa-6.mt-12(v-if="!columnasAExportar.length")
              v-icon(color="background", size="100") clear_all
              span.font-weight-700.primary--text
                | No seleccionaste ninguna columna
              span.text-muted.font-size-12 Regresa a la primera pestaña para seleccionar algunos
            div(v-else dense)
              lista-draggable(v-model="columnasAExportar"  :options="optionDragable" ghost-class="ghost" chosen-class="chosen" drag-class="drag")
                v-list.py-0(v-for='(item, i) in columnasAExportar' :key='`item-${i}`' )
                  v-list-item( :value='item' active-class='secondary primary--text' @click="() => {}")
                    v-list-item-action
                      v-icon(:color="item.color" size="12") circle
                    v-list-item-content.py-0
                      v-list-item-title
                        strong.font-size-12 {{item.nombre}}
                      v-list-item-subtitle
                        span.font-size-11.grey--text {{item.descripcionType}} / {{item.table}}
                    v-list-item-action
                      v-btn( fab color="error" @click.stop="() => { columnasAExportar.splice(i, 1) }"  x-small,)
                        v-icon remove
                    v-list-item-action.handle
                      v-btn( icon   small,)
                        v-icon drag_indicator
                  v-divider
    .mt-1.d-flex.mx-4
      span
      v-spacer
      small.font-size-11.font-weight-700 {{columnasTicket.length + columnasEstados.length + columnasEtapas.length + columnasTiempos.length}} columnas disp., {{columnasAExportar.length}}  para descargar
    .d-flex.mt-1.mb-4.mx-4(:class="{'fd-column' : isMovil}")
      v-btn(  color="error" :small="!isMovil", :block="isMovil" @click="closeDialogExportar()"  :class="{'mx-2' : !isMovil}")
        | Cancelar exportacion
      v-spacer
      v-btn(  color="success" :small="!isMovil", :block="isMovil" @click="fetchExportarReporte()" :class="{'mt-2' : isMovil}")
        | Exportar informacion
</template>
<script>
import { apiGet, notify, apiPost } from '../util/general'
import draggable from 'vuedraggable'
export default {
  props : ['id', 'preview', 'tipo', 'filtros', 'tipoPredefinido', 'tipoticket'],
  components : {
    'lista-draggable' : draggable
  },
  data () {
    return {
      tab              : 0,
      idReporte        : this.id || 0,
      columnasAExportar: [],
      columnasTicket   : [],
      columnasEtapas   : [],
      columnasEstados  : [],
      columnasTiempos  : [],
      formatosExportar : [
        'Excel'
      ],
      formatoAExportar                 : 'Excel',
      tipoPreview                      : this.preview || 'draft',
      tipoReporte                      : this.tipo || '',
      filtrosDraft                     : this.filtros || {},
      isColumnasAllSeleccionadasTicket : false,
      isColumnasAllSeleccionadasEtapas : false,
      isColumnasAllSeleccionadasTiempos: false,
      isColumnasAllSeleccionadasEstados: false,
      descripcionPredefinido           : this.tipoPredefinido ? `tickets-${this.tipoticket}-${this.tipoPredefinido.replace(' ', '-')}` : '',
      reportesPredefinidos             : [],
      optionDragable                   : {
        animation: 0,
        group    : 'description',
        handle   : '.handle'
      }
    }
  },
  created () {
    var vm = this
    vm.fetchColumnasDeLaTablaTicket()
    vm.fetchObtenerColumnsEtapasEstados('etapas')
    vm.fetchObtenerColumnsEtapasEstados('estados')
    vm.fetchObtenerColumnsEtapasEstados('tiempos')
    if (vm.descripcionPredefinido && vm.tipoticket) {
      vm.fetchObtenerListadoReportes()
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  methods : {
    countLengthColumns (tipo) {
      var vm = this
      var ticketCount = 0
      var estadoCount = 0
      var etapaCount  = 0
      var tiempoCount = 0
      for (var i = 0; i < vm.columnasAExportar.length; i++) {
        var e = vm.columnasAExportar[i];
        if (e.isTicket) ticketCount++
        else if (e.isEstado) estadoCount++
        else if (e.isEtapa) etapaCount++
        else if (e.isTiempo) tiempoCount++
      }

      if (tipo === 'ticket') return ticketCount
      else if (tipo === 'estado') return estadoCount
      else if (tipo === 'etapa') return etapaCount
      else if (tipo === 'tiempo') return tiempoCount
    },
    seleccionarTodasLasColumnasTicket () {
      var vm = this
      if (vm.isColumnasAllSeleccionadasTicket) {
        vm.columnasAExportar = vm.columnasAExportar.filter(e => !e.isTicket)
        vm.columnasTicket.forEach((el, i) => {
          vm.columnasAExportar.push(el)
        })
      } else {
        vm.columnasAExportar = vm.columnasAExportar.filter(e => !e.isTicket)
      }
    },
    seleccionarTodasLasColumnasEstados () {
      var vm = this
      if (vm.isColumnasAllSeleccionadasEstados) {
        vm.columnasAExportar = vm.columnasAExportar.filter(e => !e.isEstado)
        vm.columnasEstados.forEach((el, i) => {
          vm.columnasAExportar.push(el)
        })
      } else {
        vm.columnasAExportar = vm.columnasAExportar.filter(e => !e.isEstado)
      }
    },
    seleccionarTodasLasColumnasEtapas () {
      var vm = this
      if (vm.isColumnasAllSeleccionadasEtapas) {
        vm.columnasAExportar = vm.columnasAExportar.filter(e => !e.isEtapa)
        vm.columnasEtapas.forEach((el, i) => {
          vm.columnasAExportar.push(el)
        })
      } else {
        vm.columnasAExportar = vm.columnasAExportar.filter(e => !e.isEtapa)
      }
    },
    seleccionarTodasLasColumnasTiempos () {
      var vm = this
      if (vm.isColumnasAllSeleccionadasTiempos) {
        vm.columnasAExportar = vm.columnasAExportar.filter(e => !e.isTiempo)
        vm.columnasTiempos.forEach((el, i) => {
          vm.columnasAExportar.push(el)
        })
      } else {
        vm.columnasAExportar = vm.columnasAExportar.filter(e => !e.isTiempo)
      }
    },
    closeDialogExportar () {
      var vm = this
      vm.$emit('close')
    },
    async fetchExportarReporte () {
      var vm = this
      if (!vm.columnasAExportar.length) {
        notify(vm, 'error', 'Error', 'Por favor seleccione algunas columnas para exportar')
        return;
      }

      var url = 'ticket/obtener/reporte'
      if (vm.descripcionPredefinido) {
        var reporteId = vm.reportesPredefinidos.find(e => e.descripcion === vm.descripcionPredefinido)
        vm.idReporte = reporteId.id
      }

      var isAddColumnsTicket  = await vm.columnasAExportar.some(e => e.isTicket)
      var isAddFechasEstado   = await vm.columnasAExportar.some(e => e.isEstado)
      var isAddFechasEtapas   = await vm.columnasAExportar.some(e => e.isEtapa)
      var isAddFechasTiempos  = await vm.columnasAExportar.some(e => e.isTiempo)

      var obj = {
        idReporte         : vm.idReporte,
        columnas          : vm.columnasAExportar,
        tipoPreview       : vm.tipoPreview,         // save o draft
        tipoReporte       : vm.tipoReporte,         // basico o avanzado
        filtrosDraft      : vm.filtrosDraft,        // filtros basicos o avanzados,
        isExcel           : true,
        isAddFechasEstado : isAddFechasEstado,
        isAddFechasEtapas : isAddFechasEtapas,
        isAddFechasTiempos: isAddFechasTiempos,
        isAddColumnsTicket: isAddColumnsTicket
      }

      console.log('obj', obj)

      apiPost(vm, url, obj, function (data) {
        vm.closeDialogExportar()
        vm.$store.dispatch('setOpenPopupNotifications', true)
        vm.$store.dispatch('openProcesos')
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      })
    },
    fetchColumnasDeLaTablaTicket () {
      var vm = this
      var url = '/ticket/get/columns'
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo columnas predeterminadas' })
      var obj = {
        formateado : true
      }
      apiGet(vm, url, obj, function (data) {
        for (let i = 0; i < data.lista.length; i++) {
          vm.columnasTicket.push(data.lista[i])
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
      })
    },
    fetchObtenerListadoReportes () {
      var vm = this
      var url = 'reporte/obtener'
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo listado de reportes' })
      var obj = {
        tipoListado : 1
      }

      apiGet(vm, url, obj, function (data) {
        vm.reportesPredefinidos = data.lista
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
      })
    },
    fetchObtenerColumnsEtapasEstados (tipo) {
      var vm = this
      var url = 'ticket/get/columns/etapas/estados'
      vm.$store.dispatch('transaccion', { isProceso : true, message : 'Obteniendo columnas adicionales.' })
      var tipoTicketEnviar = ''
      if (vm.tipoPreview === 'draft') {
        if (vm.filtrosDraft.hasOwnProperty('tipo')) {
          if (vm.filtrosDraft.tipo !== '-1') {
            tipoTicketEnviar = vm.filtrosDraft.tipo
          }
        }
      } else {
        tipoTicketEnviar = vm.tipoticket
      }
      var obj = {
        tipo      : tipo,
        tipoTicket: tipoTicketEnviar,
        idReporte : vm.id
      }

      console.log('envio estpas', obj)

      apiGet(vm, url, obj, function (data) {
        console.log('regreso etapas', data)
        for (let i = 0; i < data.columnas.length; i++) {
          if (tipo === 'etapas') vm.columnasEtapas.push(data.columnas[i])
          else if (tipo === 'estados') vm.columnasEstados.push(data.columnas[i])
          else if (tipo === 'tiempos') vm.columnasTiempos.push(data.columnas[i])
        }
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.$store.dispatch('transaccion', {isProceso : false})
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.chosen
  opacity      : 0.6
  color white
  background   : #d1d1d1;
  border-radius: 0;
  transition   : background-color 0.25s, border-radius 0.25s;
.handle
  cursor: move;

</style>



// WEBPACK FOOTER //
// c_reporte_parametros_exportacion.vue?85ad64c0